"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _Cart = _interopRequireDefault(require("./Cart"));

var _CartIcon = _interopRequireDefault(require("./CartIcon"));

var _popover = _interopRequireDefault(require("@ux/popover"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _config = _interopRequireDefault(require("../utils/config"));

var _constants = require("../utils/constants");

var _helpers = require("../utils/helpers");

var _reactIntl = require("react-intl");

var _services = _interopRequireDefault(require("../utils/services"));

var _namespaceComponent = require("@ux/namespace-component");

var _cart = _interopRequireDefault(require("@ux/cart"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

var HeaderCart =
/*#__PURE__*/
function (_NamespaceConsumer) {
  _inherits(HeaderCart, _NamespaceConsumer);

  function HeaderCart(props) {
    var _getPrototypeOf2;

    var _this;

    _classCallCheck(this, HeaderCart);

    for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
      args[_key - 1] = arguments[_key];
    }

    _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(HeaderCart)).call.apply(_getPrototypeOf2, [this, props].concat(args)));
    _this.state = {
      open: false,
      enabled: false,
      loading: false,
      basket: {},
      checkoutUrl: props.checkout
    };
    _this.enable = _this.enable.bind(_assertThisInitialized(_this));
    _this.open = _this.open.bind(_assertThisInitialized(_this));
    _this.close = _this.close.bind(_assertThisInitialized(_this));
    _this["continue"] = _this["continue"].bind(_assertThisInitialized(_this));
    _this.setProps = _this.setProps.bind(_assertThisInitialized(_this));
    _this.isHeaderCartEligible = _this.isHeaderCartEligible.bind(_assertThisInitialized(_this));
    _this.getBasket = _this.getBasket.bind(_assertThisInitialized(_this));

    _config["default"].init({
      baseUrl: props.checkout
    });

    return _this;
  }

  _createClass(HeaderCart, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      document.addEventListener(_constants.Events.ENABLE, this.enable);
      document.addEventListener(_constants.Events.ADD_ITEM, this.open);
      document.addEventListener(_constants.Events.PROPS, this.setProps);
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      document.removeEventListener(_constants.Events.ENABLE, this.enable);
      document.removeEventListener(_constants.Events.ADD_ITEM, this.open);
      document.removeEventListener(_constants.Events.PROPS, this.setProps);
    }
  }, {
    key: "getBasket",
    value: function getBasket() {
      var _this2 = this;

      this.setState({
        loading: true
      });

      _services["default"].basket.get().then(function (basket) {
        _this2.setState({
          basket: basket,
          loading: false
        });
      })["catch"](function () {
        _this2.setState({
          loading: false
        });
      });
    }
  }, {
    key: "isHeaderCartEligible",
    value: function isHeaderCartEligible() {
      var isIE = typeof window !== 'undefined' && (
      /* @cc_on!@*/
      false || !!document.documentMode);
      return this.state.enabled && !this.isMobile && !isIE;
    }
  }, {
    key: "continue",
    value: function _continue() {
      window.location = this.state.checkoutUrl;
    }
  }, {
    key: "enable",
    value: function enable() {
      this.setState({
        enabled: true
      }, this.getBasket);
    }
  }, {
    key: "open",
    value: function open() {
      this.setState({
        open: true
      });
    }
  }, {
    key: "close",
    value: function close() {
      this.setState({
        open: false
      });
    }
  }, {
    key: "setProps",
    value: function setProps(event) {
      if (event.detail && event.detail.checkoutUrl) {
        this.setState({
          checkoutUrl: event.detail.checkoutUrl
        });
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this3 = this;

      var _this$state = this.state,
          basket = _this$state.basket,
          loading = _this$state.loading;
      var market = (0, _helpers.getMarket)();
      var currency = (0, _helpers.getCurrency)();
      var messages = this.props.messages;
      var language = {
        firstYear: messages['Shared:UtilityBar:HeaderCart:firstYear'],
        secondPlusYear: messages['Shared:UtilityBar:HeaderCart:secondPlusYear'],
        itemEditor: {
          month: messages['Shared:UtilityBar:HeaderCart:itemEditor:month'],
          months: messages['Shared:UtilityBar:HeaderCart:itemEditor:months'],
          year: messages['Shared:UtilityBar:HeaderCart:itemEditor:year'],
          years: messages['Shared:UtilityBar:HeaderCart:itemEditor:years']
        }
      };

      var headerCart = _react["default"].createElement("div", {
        className: this.namespace('hc-header-cart')
      }, _react["default"].createElement(_reactIntl.IntlProvider, {
        locale: market,
        key: market,
        messages: messages
      }, _react["default"].createElement(_popover["default"], {
        control: _react["default"].createElement(_CartIcon["default"], _extends({}, this.props, {
          items: basket && basket.items && basket.items.length
        })),
        eid: 'gce.header_cart.sales_header.icon.click',
        open: this.state.open,
        onToggle: function onToggle(open) {
          return open ? _this3.open() : _this3.close();
        }
      }, _react["default"].createElement(_Cart["default"], {
        basket: basket,
        loading: loading,
        onChange: this.getBasket,
        onClose: this.close,
        onContinue: this["continue"],
        currency: currency,
        market: market,
        language: language
      }))));

      return this.isHeaderCartEligible() ? headerCart : _react["default"].createElement(_cart["default"], this.props);
    }
  }]);

  return HeaderCart;
}(_namespaceComponent.NamespaceConsumer);

HeaderCart.propTypes = {
  // preserving existing prop names for compatibility
  checkout: _propTypes["default"].string.isRequired,
  items: _propTypes["default"].number
};
var _default = HeaderCart;
exports["default"] = _default;